import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderProcess extends BaseModelAPI {
	static entity = 'workorderprocess';
	static entityName = 'workorderprocess';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.workOrderProcessNumber = '';
			this.productionDate = '';
			this.lineCodeId = '';
			this.lineCode = {};
			this.processTypeId = '';
			this.processType = {};
			this.processTypeName = '';
			this.documentStatusId = '';
			this.documentStatus = {};
			this.workOrderProcessDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async printWoList(this_, id, wopNumber) {
        let _this = this;
        return await this_.$http.get(`${this.entityName}/printwolist/${id}/?wopNumber=${wopNumber}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
    }

}